import React, { useState } from "react";
import { DatePicker } from "antd";
import { motion } from "framer-motion";

export default function InterviewSchedulePage() {
  const [date, setDate] = useState(null);

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.12 },
    },
  };

  const card = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <motion.div
      className="container-fluid p-0 bg-light"
      variants={container}
      initial="hidden"
      animate="show"
    >
      <div className="card border-0 shadow-sm rounded-0">

        {/* HEADER */}
        <div className="border-bottom px-3 py-2 bg-white">
          <h6 className="m-0 fw-semibold text-primary">
            Interview Schedule
          </h6>
        </div>

        <div className="px-2 py-2">

          <div className="row g-2">

            {/* CALENDAR */}
            <div className="col-lg-3 col-md-4">

              <motion.div className="card p-2 shadow-sm" variants={card}>
                <DatePicker
                  value={date}
                  onChange={(value) => setDate(value)}
                  className="w-100"
                />
              </motion.div>

            </div>

            {/* FORM */}
            <div className="col-lg-9 col-md-8">

              <motion.div className="card p-2 shadow-sm" variants={card}>

                <div className="row g-2">

                  <div className="col-md-6">
                    <input className="form-control form-control-sm" placeholder="Candidate Name" />
                  </div>

                  <div className="col-md-6">
                    <input className="form-control form-control-sm" placeholder="Email" />
                  </div>

                  <div className="col-md-6">
                    <DatePicker
                      className="w-100"
                      showTime
                      onChange={(value) => setDate(value)}
                    />
                  </div>

                  <div className="col-md-6">
                    <select className="form-select form-select-sm">
                      <option>Technical</option>
                      <option>HR</option>
                      <option>Manager</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <select className="form-select form-select-sm">
                      <option>Online</option>
                      <option>Face to Face</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <input className="form-control form-control-sm" placeholder="Interviewer Name" />
                  </div>

                  <div className="col-12">
                    <textarea className="form-control form-control-sm" rows="2" placeholder="Remarks" />
                  </div>

                </div>

                {/* BUTTONS */}
                <div className="text-end mt-2">
                  <button className="btn btn-sm btn-outline-danger me-2">
                    Cancel
                  </button>
                  <button className="btn btn-sm btn-outline-primary">
                    Schedule
                  </button>
                </div>

              </motion.div>

            </div>

          </div>

        </div>
      </div>
    </motion.div>
  );
}
